(() => {
class $fbe05942f27f3338$var$PredictiveSearch extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResultsWrapper = this.querySelector('#predictiveSearchResultsWrapper');
        this.input.addEventListener('input', this.debounce((event)=>{
            this.onChange(event);
        }, 300).bind(this));
    }
    onChange() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
            this.close();
            return;
        }
        this.getSearchResults(searchTerm);
    }
    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[options][fields]=title,variants.title,tag&resources[limit_scope]=each`).then((response)=>{
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        }).then((text)=>{
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.open();
            this.predictiveSearchResultsWrapper.innerHTML = resultsMarkup;
        }).catch((error)=>{
            this.close();
            throw error;
        });
    }
    open() {
        this.parentElement.style.maxHeight = '90vh';
        this.parentElement.style.overflow = 'auto';
        this.predictiveSearchResultsWrapper.classList.add('d-block');
        this.predictiveSearchResultsWrapper.classList.remove('d-none');
        // remove 'sticky-top' from collection filter controls so they're not on top of the search results
        let filtersWrapperLg = document.getElementById('filtersWrapperLg');
        filtersWrapperLg?.classList.remove('sticky-top');
        let filterSortAccordionSm = document.getElementById('filterSortAccordionSm');
        filterSortAccordionSm?.classList.remove('sticky-top');
    }
    close() {
        this.predictiveSearchResultsWrapper.classList.remove('d-block');
        this.predictiveSearchResultsWrapper.classList.add('d-none');
        this.predictiveSearchResultsWrapper.innerHTML = '';
        // add 'sticky-top' back to collection filter controls
        let filtersWrapperLg = document.getElementById('filtersWrapperLg');
        filtersWrapperLg?.classList.add('sticky-top');
        let filterSortAccordionSm = document.getElementById('filterSortAccordionSm');
        filterSortAccordionSm?.classList.add('sticky-top');
    }
    debounce(fn, wait) {
        let t;
        return (...args)=>{
            clearTimeout(t);
            t = setTimeout(()=>fn.apply(this, args), wait);
        };
    }
}
customElements.define('predictive-search', $fbe05942f27f3338$var$PredictiveSearch);

})();
//# sourceMappingURL=predictive-search.js.map
